import ContractsTaxiForwardingContractListRequest, {
  ContractsTaxiForwardingContractListRequestOrder,
  ContractsTaxiForwardingContractListRequestModel,
} from "../../../../api/raily/contracts/taxi-forwarding/list/contracts-taxi-forwarding-contract-list.request";
import BillingModel from "../../../../types/billing-model";
import paginationService from "../../../../utils/pagination/pagination.service";
import ContractsTaxiForwardingContractListParams, {
  ContractsTaxiForwardingContractListParamsOrder,
} from "./contracts-taxi-forwarding-contract-list-params";

const createOrder = (
  sortKey: ContractsTaxiForwardingContractListParamsOrder | undefined,
): ContractsTaxiForwardingContractListRequestOrder | undefined => {
  switch (sortKey) {
    case ContractsTaxiForwardingContractListParamsOrder.PRIORITY_ASC:
      return ContractsTaxiForwardingContractListRequestOrder.PRIORITY_ASC;
    case ContractsTaxiForwardingContractListParamsOrder.PRIORITY_DESC:
      return ContractsTaxiForwardingContractListRequestOrder.PRIORITY_DESC;
    case ContractsTaxiForwardingContractListParamsOrder.DISPLAY_NAME_ASC:
      return ContractsTaxiForwardingContractListRequestOrder.DISPLAY_NAME_ASC;
    case ContractsTaxiForwardingContractListParamsOrder.DISPLAY_NAME_DESC:
      return ContractsTaxiForwardingContractListRequestOrder.DISPLAY_NAME_DESC;
    case ContractsTaxiForwardingContractListParamsOrder.PRODUCER_DISPLAY_NAME_ASC:
      return ContractsTaxiForwardingContractListRequestOrder.PRODUCER_DISPLAY_NAME_ASC;
    case ContractsTaxiForwardingContractListParamsOrder.PRODUCER_DISPLAY_NAME_DESC:
      return ContractsTaxiForwardingContractListRequestOrder.PRODUCER_DISPLAY_NAME_DESC;
    case ContractsTaxiForwardingContractListParamsOrder.CONSUMER_DISPLAY_NAME_ASC:
      return ContractsTaxiForwardingContractListRequestOrder.CONSUMER_DISPLAY_NAME_ASC;
    case ContractsTaxiForwardingContractListParamsOrder.CONSUMER_DISPLAY_NAME_DESC:
      return ContractsTaxiForwardingContractListRequestOrder.CONSUMER_DISPLAY_NAME_DESC;
    case ContractsTaxiForwardingContractListParamsOrder.HALTING_TIME_RATE_ASC:
      return ContractsTaxiForwardingContractListRequestOrder.HALTING_TIME_RATE_ASC;
    case ContractsTaxiForwardingContractListParamsOrder.HALTING_TIME_RATE_DESC:
      return ContractsTaxiForwardingContractListRequestOrder.HALTING_TIME_RATE_DESC;
    case ContractsTaxiForwardingContractListParamsOrder.DISTANCE_RATE_ASC:
      return ContractsTaxiForwardingContractListRequestOrder.DISTANCE_RATE_ASC;
    case ContractsTaxiForwardingContractListParamsOrder.DISTANCE_RATE_DESC:
      return ContractsTaxiForwardingContractListRequestOrder.DISTANCE_RATE_DESC;
    case ContractsTaxiForwardingContractListParamsOrder.HALTING_TIME_AFTER_MINUTES_ASC:
      return ContractsTaxiForwardingContractListRequestOrder.HALTING_TIME_AFTER_MINUTES_ASC;
    case ContractsTaxiForwardingContractListParamsOrder.HALTING_TIME_AFTER_MINUTES_DESC:
      return ContractsTaxiForwardingContractListRequestOrder.HALTING_TIME_AFTER_MINUTES_DESC;
    default:
      return undefined;
  }
};

const createModel = (
  billingModelFilterKey: BillingModel | undefined,
): ContractsTaxiForwardingContractListRequestModel | undefined => {
  switch (billingModelFilterKey) {
    case BillingModel.AB:
      return ContractsTaxiForwardingContractListRequestModel.AB;
    case BillingModel.ABA:
      return ContractsTaxiForwardingContractListRequestModel.ABA;
    case BillingModel.SABS:
      return ContractsTaxiForwardingContractListRequestModel.SABS;
    case BillingModel.OTHER:
      return ContractsTaxiForwardingContractListRequestModel.OTHER;
    default:
      return undefined;
  }
};

const create = (
  params: ContractsTaxiForwardingContractListParams,
): ContractsTaxiForwardingContractListRequest => {
  return {
    creationStart: params.creationDate?.from,
    creationEnd: params.creationDate?.to,
    limit: params.pageSize,
    offset:
      params.page &&
      params.pageSize &&
      paginationService.calculateOffset(params.page, params.pageSize),
    resultsOrdering: createOrder(params.order),
    producerDisplayName: params.producerDisplayName,
    consumerDisplayName: params.consumerDisplayName,
    producerTaxiId: params.producerTaxiUuid,
    startValidSince: params.periodOfValidation?.from,
    endValidTo: params.periodOfValidation?.to,
    startDistanceRate: params.distanceRate?.from,
    endDistanceRate: params.distanceRate?.to,
    startHaltingTimeAfterMinutes: params.freeStoppingPeriod?.from,
    endHaltingTimeAfterMinutes: params.freeStoppingPeriod?.to,
    startHaltingTimeRate: params.stopRate?.from,
    endHaltingTimeRate: params.stopRate?.to,
    isPartner: params.isPartner,
    isValid: params.isValid,
    disabled: params.isActive === undefined ? undefined : !params.isActive,
    priority: params.priority,
    model: createModel(params.billingModel),
    displayName: params.displayName,
    engagedTaxiId: params.engagedTaxiUuid,
  };
};

const contractsTaxiForwardingContractListParamsFactory = { create };

export default contractsTaxiForwardingContractListParamsFactory;
